<template>
  <div class="aggregator-interface-wrapper">
    <v-card
      class="interface-section-card"
      outlined
      :class="{ 'card-error': interfaceErrors.length > 0 && needInterface }"
    >
      <v-card-text>
        <p class="section-title">Apakah anda ingin menambahkan interface tambahan yang digunakan pada integrasi API?</p>
        <v-row justify="center" class="mt-4 mb-4">
          <v-radio-group v-model="needInterface" row @change="handleNeedInterfaceChange">
            <v-radio label="Tidak" :value="false"></v-radio>
            <v-radio label="Ya" :value="true"></v-radio>
          </v-radio-group>
        </v-row>

        <v-slide-y-reverse-transition>
          <div v-if="needInterface" class="interface-options">
            <v-select
              :items="interfaceOptions"
              item-text="label"
              item-value="value"
              v-model="selectedInterfaces"
              multiple
              chips
              label="Pilih Interface"
              outlined
              @change="handleInterfaceChange"
              :menu-props="{ offsetY: true, nudgeTop: -5 }"
              class="interface-select"
            >
              <template v-slot:item="{ item }">
                <div class="option-item-wrapper">
                  <div class="option-header">{{ item.label }}</div>
                  <div class="option-description">{{ item.description }}</div>
                </div>
              </template>
            </v-select>
          </div>
        </v-slide-y-reverse-transition>
      </v-card-text>
    </v-card>
    
    <p v-if="interfaceErrors.length > 0 && needInterface" class="field-error-message">
      {{ interfaceErrors[0] }}
    </p>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';

export default {
  name: 'AggregatorInterfaceField',
  mixins: [validationMixin],

  validations: {
    selectedInterfaces: {
      required() {
        return this.needInterface ? this.selectedInterfaces.length > 0 : true;
      }
    }
  },

  data() {
    return {
      interfaceOptions: [
        {
          label: 'CPTS',
          value: 'cpts',
          description: 'Digunakan untuk transaksi pembayaran menggunakan token CPTS pada integrasi API'
        }
      ]
    };
  },

  computed: {
    needInterface: {
      set(val) {
        this.$store.commit('register/setNeedInterface', val);
      },
      get() {
        return this.$store.state.register.data.needInterface;
      }
    },

    selectedInterfaces: {
      set(val) {
        this.$store.commit('register/setSelectedInterfaces', val);
      },
      get() {
        return this.$store.state.register.data.qrTypeInterface;
      }
    },

    interfaceErrors() {
      const errors = [];
      if (!this.$v.selectedInterfaces.$dirty) return errors;
      if (!this.$v.selectedInterfaces.required) errors.push('Interface is required');
      return errors;
    }
  },

  methods: {
    handleNeedInterfaceChange(val) {
      if (!val) {
        this.$store.commit('register/setSelectedInterfaces', []);
        this.$v.selectedInterfaces.$reset();
      } else {
        this.$v.selectedInterfaces.$touch();
      }
    },

    handleInterfaceChange() {
      if (this.$v.selectedInterfaces.$dirty) {
        this.$v.selectedInterfaces.$touch();
      }
    },

    touchValidation() {
      this.$v.selectedInterfaces.$touch();
    },

    resetValidation() {
      this.$v.selectedInterfaces.$reset();
    }
  }
};
</script>

<style scoped>
.aggregator-interface-wrapper {
  width: 100%;
  margin: 16px 0;
}

.interface-section-card {
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  border-radius: 4px;
  transition: border-color 0.3s ease;
}

.interface-section-card.card-error {
  border-color: #d32f2f !important;
}

.section-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  text-align: left;
}

.interface-options {
  margin-top: 16px;
  position: relative;
  z-index: auto;
}

.interface-select /deep/ .v-input__append-inner {
  margin-top: 4px !important;
}

.interface-select /deep/ .v-input__control {
  min-height: 56px !important;
}

.interface-select /deep/ .v-input__slot {
  min-height: 56px !important;
}

.interface-select /deep/ .v-select__selections {
  padding: 8px 8px !important;
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 8px !important;
  align-items: center !important;
  min-height: 40px !important;
}

.interface-select /deep/ .v-chip {
  margin: 4px !important;
  height: 32px !important;
}

.interface-select /deep/ .v-select__slot {
  padding: 0 !important;
}

.v-slide-y-reverse-transition-enter-active,
.v-slide-y-reverse-transition-leave-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.interface-container {
  width: 100%;
}

.option-item-wrapper {
  padding: 12px 16px;
  width: 100%;
  min-height: auto;
}

.option-header {
  font-weight: 500;
  font-size: 13px;
  color: #333;
  margin-bottom: 6px;
}

.option-description {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.field-error-message {
  color: #d32f2f;
  font-size: 12px;
  margin: 4px 0 0 0;
  text-align: left;
}
</style>
